import { UserGender } from './user.types'

export class UserGenderMapper {
  public static numberToString(genderNumber: number): UserGender | null {
    if (genderNumber === 1) return 'Male'
    if (genderNumber === 2) return 'Female'
    return null
  }
}
